module.exports = __webpack_public_path__ + "assets/img/pause.f46808ce.svg";